import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedSvgComponent } from './shared-svg.component';

@NgModule({
  declarations: [
    SharedSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    SharedSvgComponent
  ]
})
export class SharedSvgModule { }
